const worldbossPositions = `

#### Gigginox - Level 120 (Respawn: 1 hour)
![Gigginox](assets/guide/gigginoxus.png)

#### Shiva - Level 150 (Respawn: 1 hour)
![Shiva](assets/guide/shivaus.png)

#### Vangau - Level 160 (Respawn: 1 hour)
![Vangau](assets/guide/vangauus.png)

#### Harlos - Level 170 (Respawn: 1 hour)
![Harlos](assets/guide/Harlos_us.png)

#### Clios - Level 180 (Respawn: 1 hour)
![Clios](assets/guide/Clios_us.png)

#### Lilitas - Level 190 (Respawn: 1 hour) & Phoenix - Level 200 (Respawn: 1 hour)
![Lilitas & Phoenix](assets/guide/lilitas_phoenix.png)

Stay prepared and hunt down the **Worldbosses** for epic rewards!`;

export default worldbossPositions;
